import Reveal from "./animations/Reveal";

function TitleHeading(props) {
    return (
        <>
            {
                props?.btnBackHref ?
                <div className="container back pt-4">
                    <a href = {props.btnBackHref} >
                        <i className="ion-chevron-left me-2" />
                        Back
                    </a>
                </div>
                : ""
            }
        <Reveal className="font-title" y={24} duration={0.7}>
            <h2 className={props?.className}>{props?.title}<span>{props?.subtitle ? " - " + props.subtitle : ""}</span></h2>
        </Reveal>
        </>
    )
}
export default TitleHeading;
